import { applyMiddleware, combineReducers, createStore } from 'redux';
import userReducer from 'reducers/userReducer';
import modalReducer from 'reducers/modalReducer';
import userFeedbackReducer from 'reducers/userFeedbackReducer';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import notificationReducer from 'reducers/notificationReducer';
import partnerFormReducer from 'reducers/partnerFormReducer';
import caseReducer from 'reducers/caseReducer';
import brTabsReducer from 'reducers/brTabsReducer';
import dlmReducer from 'reducers/dlmReducer';
import debugInfoReducer from 'reducers/debugInfoReducer';
import drawerReducer from 'reducers/drawerReducer';

export const reducer = combineReducers({
  user: userReducer,
  modal: modalReducer,
  notifications: notificationReducer,
  userFeedback: userFeedbackReducer,
  partnerForm: partnerFormReducer,
  caseInformation: caseReducer,
  brTabs: brTabsReducer,
  dlm: dlmReducer,
  debugInfo: debugInfoReducer,
  drawer: drawerReducer,
});

const middlewares = [thunk];
const middlewareEnhancer = applyMiddleware(...middlewares);
const storeEnhancers = [middlewareEnhancer];
const composedEnhancer = composeWithDevTools(...storeEnhancers);
const store = createStore(reducer, composedEnhancer);

export default store;
